// ContinueWatching.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import './ContinueWatching.css';

type ProfileType = 'recruiter' | 'tech_enthusiast' | 'stalker' | 'adventurer'; // <-- CHANGED

interface ContinueWatchingProps {
  profile: ProfileType;
}

const continueWatchingConfig = {
  recruiter: [
    { title: "Music", imgSrc: "https://picsum.photos/id/1025/300/200", link: "/music" },
    { title: "Freelance Services", imgSrc: "https://picsum.photos/id/1027/300/200", link: "/freelance-services" },
    { title: "Places Visited", imgSrc: "https://picsum.photos/id/1026/300/200", link: "/places-visited" },
    { title: "Contact Me", imgSrc: "https://picsum.photos/id/1029/300/200", link: "/contact-me" }
  ],
  tech_enthusiast: [ // <-- CHANGED
    { title: "Music", imgSrc: "https://picsum.photos/id/1025/300/200", link: "/music" },
    { title: "Places Visited", imgSrc: "https://picsum.photos/id/1026/300/200", link: "/places-visited" },
    { title: "Freelance Services", imgSrc: "https://picsum.photos/id/1027/300/200", link: "/freelance-services" },
    { title: "Certifications", imgSrc: "https://picsum.photos/id/1028/300/200", link: "/certifications" },
    { title: "Contact Me", imgSrc: "https://picsum.photos/id/1029/300/200", link: "/contact-me" }
  ],
  stalker: [
    { title: "Places Visited", imgSrc: "https://picsum.photos/id/1026/300/200", link: "/places-visited" },
    { title: "Freelance Services", imgSrc: "https://picsum.photos/id/1027/300/200", link: "/freelance-services" },
    { title: "Contact Me", imgSrc: "https://picsum.photos/id/1029/300/200", link: "/contact-me" }
  ],
  adventurer: [
    { title: "Music", imgSrc: "https://picsum.photos/id/1025/300/200", link: "/music" },
    { title: "Certifications", imgSrc: "https://picsum.photos/id/1028/300/200", link: "/certifications" },
    { title: "Contact Me", imgSrc: "https://picsum.photos/id/1029/300/200", link: "/contact-me" }
  ]
};

const ContinueWatching: React.FC<ContinueWatchingProps> = ({ profile }) => {
  const continueWatching = continueWatchingConfig[profile];
  // Replaces underscores with spaces for display
  const displayName = profile.replace(/_/g, ' '); 

  return (
    <div className="continue-watching-row">
      <h2 className="row-title">Continue Watching for {displayName}</h2> {/* Use displayName */}
      <div className="card-row">
        {continueWatching.map((pick, index) => (
          <Link to={pick.link} key={index} className="pick-card">
            <img src={pick.imgSrc} alt={pick.title} className="pick-image" loading="lazy" />
            <div className="overlay">
              <div className="pick-label">{pick.title}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ContinueWatching;